import { useTheme } from "@hooks";
import { styles } from "./styles";
import { CheckMarkProps } from "./types";

export const CheckMark = ({ background: backgroundProp, fill: fillProp }: CheckMarkProps) => {
  const { theme } = useTheme();

  const background = backgroundProp ?? theme.button.background.inverse;
  const fill = fillProp ?? theme.text.default;

  return (
    <svg
      width="90"
      height="90"
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={styles.checkMark}
    >
      <rect x="0.25" width="89.5" height="89.5" rx="44.75" fill={background} />
      <path
        d="M41.3447 55.1748L59.9559 36.5636L57.1868 33.7944L41.3447 49.6365L33.6813 41.9731L30.9121 44.7422L41.3447 55.1748Z"
        fill={fill}
      />
    </svg>
  );
};
